<template>
  <div class="flex w-screen flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px]">
    <div class="container mx-auto flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px]">
      <!-- Banner -->
      <Banner title="FHE_C8_T" description="FHE_C8_D" />
      <div class="bg-white">
        <div
          class="container xl:px-[50px] px-0 flex flex-col gap-4 sm:gap-5 md:gap-6 lg:gap-7.5 mx-auto"
        >
          <div class="flex flex-col md:flex-row justify-between gap-4">
            <ContentBlock
              :scrollable-content="pickupContent.PF_SCROLLABLE_CONTENT1"
              :carousel-images="pickupContent.PF_CONTENT1_IMAGES"
              :reverse="true"
            />
            <ContentBlock
              :scrollable-content="pickupContent.PF_SCROLLABLE_CONTENT2"
              :carousel-images="pickupContent.PF_CONTENT2_IMAGES"
            />
          </div>
          <div class="flex flex-col md:flex-row justify-between gap-4">
            <ContentBlock
              :scrollable-content="pickupContent.PF_SCROLLABLE_CONTENT3"
              :carousel-images="pickupContent.PF_CONTENT3_IMAGES"
              :reverse="true"
            />
            <ContentBlock
              :scrollable-content="pickupContent.PF_SCROLLABLE_CONTENT4"
              :carousel-images="pickupContent.PF_CONTENT4_IMAGES"
            />
          </div>
        </div>
      </div>

      <!-- Card setion -->
      <cardSetion title="HP_BENEFITS" :cards="cards" :card-background="true" />
      <TouchWithUs :background="true" />
    </div>
    <!-- Footer -->
    <Footer id="contact" />
  </div>
</template>

<script>
import TouchWithUs from '@src/views/home-page/TouchWithUs.vue'
import ContentBlock from '@/src/views/features/ContentBlock.vue'
import { navbarLinks } from '@src/constants/general-constants'
import Banner from '@/src/components/misc/Banner.vue'
import cardSetion from '@/src/views/home-page/CardSection.vue'
import Footer from '@/src/components/misc/Footer.vue'
import { useMeta } from 'vue-meta'
export default {
  components: {
    ContentBlock,
    TouchWithUs,
    Banner,
    cardSetion,
    Footer,
  },
  setup() {
    useMeta({
      title: 'Features',
      meta: [
        {
          name: 'description',
          content: 'Home',
        },
      ],
    })
  },
  data() {
    return {
      contentData: '',
      navbarLinks,
      pickupContent: {
        PF_CONTENT1_IMAGES: [
          {
            logo: require('@src/assets/images/features/pickupAllRequest.png'),
            alt: 'Fee Type 1',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/pickupFeatureSetting.png'),
            alt: 'Fee Type 2',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/pickupRequestDetails.png'),
            alt: 'Fee Type 3',
            classes: 'feature-carousel-height',
          },
        ],
        PF_SCROLLABLE_CONTENT1: {
          mainHeading: 'PICKUP_FACILITY_CAROUSEL_HEADING_1',
          card: [{ active: false }],
        },
        PF_CONTENT2_IMAGES: [
          {
            logo: require('@src/assets/images/features/activeRequest.png'),
            alt: 'fee analytics 1',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/dispatcherAllRequest.png'),
            alt: 'fee analytics 2',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/pickupPermission.png'),
            alt: 'fee analytics 3',
            classes: 'feature-carousel-height',
          },
        ],
        PF_SCROLLABLE_CONTENT2: {
          mainHeading: 'PICKUP_FACILITY_CAROUSEL_HEADING_2',
          card: [{ active: false }],
        },

        PF_CONTENT3_IMAGES: [
          {
            logo: require('@src/assets/images/features/pickupRequestDetails.png'),
            alt: 'Fee Type 1',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/generateRequest.png'),
            alt: 'Fee Type 2',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/pickupFeatureSetting.png'),
            alt: 'Fee Type 3',
            classes: 'feature-carousel-height',
          },
        ],
        PF_SCROLLABLE_CONTENT3: {
          mainHeading: 'PICKUP_FACILITY_CAROUSEL_HEADING_3',
          card: [{ active: false }],
        },
        PF_CONTENT4_IMAGES: [
          {
            logo: require('@src/assets/images/features/generateRequest.png'),
            alt: 'fee analytics 1',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/pickupRequestDetails.png'),
            alt: 'fee analytics 2',
            classes: 'feature-carousel-height',
          },
          {
            logo: require('@src/assets/images/features/activeRequest.png'),
            alt: 'fee analytics 3',
            classes: 'feature-carousel-height',
          },
        ],
        PF_SCROLLABLE_CONTENT4: {
          mainHeading: 'PICKUP_FACILITY_CAROUSEL_HEADING_4',
          card: [{ active: false }],
        },
      },
      cards: [
        {
          id: 1,
          parentRoute: 'features',
          title: 'PICKUP_FACILITATOR_BENEFITS_HEADING_1',
          description: 'PICKUP_FACILITATOR_BENEFITS_DESCRIPTION_1',
          color: 'primary-purple-600',
          shadow: 'shadow-primary-purple-600',
        },
        {
          id: 2,
          parentRoute: 'features',
          title: 'PICKUP_FACILITATOR_BENEFITS_HEADING_2',
          description: 'PICKUP_FACILITATOR_BENEFITS_DESCRIPTION_2',
          color: 'secondary-orange-500',
          shadow: 'shadow-secondary-orange-500',
        },
        {
          id: 3,
          parentRoute: 'features',
          title: 'PICKUP_FACILITATOR_BENEFITS_HEADING_3',
          description: 'PICKUP_FACILITATOR_BENEFITS_DESCRIPTION_3',
          color: 'success-500',
          shadow: 'shadow-primary-light-green ',
        },
        {
          id: 4,
          parentRoute: 'features',
          title: 'PICKUP_FACILITATOR_BENEFITS_HEADING_4',
          description: 'PICKUP_FACILITATOR_BENEFITS_DESCRIPTION_4',
          color: 'error-600',
          shadow: 'shadow-error-600',
        },
      ],
    }
  },
}
</script>
